import { DefectSelection } from "../DefectSelection";
import { faArrowDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { InspectorContext } from "../../reducer";
import { InspectorRow } from "@/api/hitachi/rbi";
import { MinMaxInput } from "@/components";
import { useAcceptRejectAll, useHandleFieldChanged } from "../../hooks";
import { useContext } from "react";
import { useModal } from "@/hooks";

export function VT() {
  const { state, updateState } = useContext(InspectorContext);

  const modal = useModal();
  const acceptReject = useAcceptRejectAll();
  const handleFieldChanged = useHandleFieldChanged();
  const hasRepairs = state.inspections.some((x) => x.weldRepairWeld);

  function normalizeCopiedValue(field: keyof InspectorRow, value?: string) {
    if (!value) {
      return value;
    }

    const numericValue = Number(value);
    if (!Number.isFinite(numericValue)) {
      return value;
    }

    if (field === "luxLevel") {
      return `${Math.max(500, numericValue)}`;
    }

    return value;
  }
  function handleCopy(field: keyof InspectorRow, value?: string) {
    const copiedValue = normalizeCopiedValue(field, value);

    updateState({
      type: "Inspections",
      payload: state.inspections.map((process) => {
        return { ...process, [field]: copiedValue };
      }),
    });
  }

  return (
    <>
      <thead>
        <tr>
          <th>Weld Map</th>
          <th>Drawing No.</th>
          <th>Weld ID No.</th>
          <th>Work Instruction</th>
          <th>Joint Type</th>
          <th>Defect Acceptance Level</th>
          <th>Lux Level</th>
          {state.inspections.length > 1 && <th />}
          <th>Accept</th>
          <th>Reject</th>
          <th>Defects</th>
        </tr>
      </thead>
      <tbody>
        {state.inspections.map((row, index) => (
          <tr key={index}>
            <td>{row.weldMap}</td>
            <td>{row.drawingNumber}</td>
            <td>{row.weldNumber}</td>
            <td>{row.workInstruction}</td>
            <td>{row.jointType}</td>
            <td>{row.acceptanceLevel}</td>
            <td>
              <MinMaxInput
                min={500}
                className="form-control"
                value={row.luxLevel ?? ""}
                onChange={(e) => handleFieldChanged(index, "luxLevel", e.currentTarget.value)}
              />
            </td>
            {state.inspections.length > 1 && (
              <td className="align-middle p-0">
                {index === 0 && (
                  <FontAwesomeIcon
                    icon={faArrowDown}
                    size="sm"
                    type="button"
                    title="Copy"
                    onClick={() => handleCopy("luxLevel", row.luxLevel)}
                  />
                )}
              </td>
            )}
            <td>
              <input
                type="radio"
                className="form-check-input"
                name={`result${index}`}
                checked={row.accept === true}
                onChange={() => handleFieldChanged(index, "accept", true)}
                onClick={(e) => e.currentTarget.checked && handleFieldChanged(index, "accept", undefined)}
                disabled={!row.luxLevel}
              />
            </td>
            <td>
              <input
                type="radio"
                className="form-check-input"
                name={`result${index}`}
                checked={row.accept === false}
                onChange={() => handleFieldChanged(index, "accept", false)}
                onClick={(e) => e.currentTarget.checked && handleFieldChanged(index, "accept", undefined)}
                disabled={!row.luxLevel}
              />
            </td>
            <td>
              <button
                role="link"
                className="btn btn-link"
                disabled={row.accept !== false}
                onClick={() =>
                  modal.show(
                    <DefectSelection
                      caption="Defects"
                      weld={row}
                      onAccept={(defects) => handleFieldChanged(index, "defects", defects)}
                    />
                  )
                }
              >
                {row.defects?.length > 0 ? `${row.defects?.length} Selected` : "Click to select"}
              </button>
            </td>
          </tr>
        ))}
      </tbody>

      {state.inspections.length > 1 && (
        <tfoot>
          <tr>
            <td />
            <td />
            <td />
            <td />
            <td />
            {hasRepairs && state.discipline !== "PMIVT" && <td />}
            <td />
            {state.inspections.length > 1 && <td />}
            <td>
              <button type="button" className="btn btn-default btn-sm" onClick={acceptReject.acceptAll}>
                Accept all
              </button>
            </td>
            <td>
              <button type="button" className="btn btn-default btn-sm" onClick={acceptReject.rejectAll}>
                Reject All
              </button>
            </td>
            <td />
          </tr>
        </tfoot>
      )}
    </>
  );
}
